
import { defineComponent } from 'vue';
import baseSubscription from '@/components/view/common/subscription';

export default defineComponent({
    components: {
        baseSubscription
    }
});
